import { useEffect, useRef, useState } from 'react';
import api from '../api';

const MAX_TRIES = 5;
const DELAY_MS = 3000;

export function useOrderPolling(orderReference) {
  const timeoutRef = useRef(null);
  const controllerRef = useRef(null);
  const attemptsRef = useRef(0);

  const [retryLimitReached, setRetryLimitReached] = useState(false);
  const [isPolling, setIsPolling] = useState(false);

  useEffect(() => {
    if (!orderReference) return;

    attemptsRef.current = 0;
    setRetryLimitReached(false);
    setIsPolling(true);

    const poll = async () => {
      if (attemptsRef.current >= MAX_TRIES) {
        setRetryLimitReached(true);
        setIsPolling(false);
        return;
      }

      attemptsRef.current += 1;
      controllerRef.current = new AbortController();

      try {
        //NOTE: Pass ro as a default language in order to pass the validator
        const res = await api.get(`/orders/${orderReference}/tickets?language=ro`, {
          responseType: 'blob',
          signal: controllerRef.current.signal,
        });

        if (res.status === 200) {
          setIsPolling(false);
          return;
        }
      } catch (e) {
        if (e.code !== 'ERR_CANCELED') {
          console.error(e);
        }
      }

      timeoutRef.current = setTimeout(poll, DELAY_MS);
    };

    poll();

    return () => {
      controllerRef.current?.abort();
      clearTimeout(timeoutRef.current);
      setIsPolling(false);
    };
  }, [orderReference]);

  return {
    isPolling,
    retryLimitReached,
  };
}
